import React, { useState, useEffect } from 'react' 
import { useNavigate, useLocation, Link } from 'react-router-dom';

import axios from "axios";
import swal from "sweetalert";

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default function ContentEdit() {
  const {state:{id}} = useLocation();
  const nav = useNavigate();
  let [contentData, setContentData] = useState({});
  const [lang, setLang] = useState('en');
  const [subjectError , setSubjectError] = useState('');
  const [contentError , setContentError] = useState('');

  const [contentData1 , setVal] = useState("");

  useEffect(()=>{
    console.log(' :Load Data: ', id);
    getStaticContent('en')
    
  },[]);

  const getStaticContent = (language) => {
    axios.get(process.env.REACT_APP_API_KEY + "api/admin/static-content-show/"+id+"/"+language, {
        headers: {
            "Content-type": "Application/json",
            "Authorization": localStorage.getItem("token")
      }   
    })
    .then((response) => {
        //Check for Authorized
      if(response.data.code == 403){
        localStorage.clear();
        nav('/admin/login');
      }
      
        if(response.data.status == true) {
            var responseData = response.data.data;
            
            setContentData({
                key:responseData.key,
                subject:responseData.subject,
                content:responseData.content
            })
            console.log("contentData ==> ", contentData)
        }})
        .catch(error => {
            console.log('error => ',error.response.data);
        })    
  }

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    console.log('name===> ',name ,' values====> ', value)
    setContentData(values => ({...values,[name]:value}))
    
    if (event.target.name == 'lang'){
      setLang(value)
      getStaticContent(value);
    //   seteditorState(value);
    } 
  }

  const editorOnChnage = (e, editor) => {
    //setVal(editor.getData())
    setVal({...contentData, content: editor.getData()})
    console.log('condent data =>', contentData1)
    console.log('condent data =>', contentData)
    
  }

  const updateStaticContent = async() =>{
    console.log("updated data ==> ", contentData1)
      await axios.post(process.env.REACT_APP_API_KEY+"api/admin/static-content-update/"+id+"/"+lang,(contentData1.content == contentData.content ? contentData : contentData1), 
      {
        headers: {
        "Content-type": "Application/json",
        "Authorization": localStorage.getItem("token")
        }   
      }
      ).then((res)=>{
        //Check for Authorized
        if(res.data.code == 403){
          localStorage.clear();
          nav('/admin/login');
        }

        if (res.data.status == true){
            swal({
                title: "Status",
                text: "Static content updated successfully!",
                icon: "success",
                button: "Okay",
              });
              nav('/admin/static-content-list');
        }else{
          const resdata = res.data.data;
          console.log("key=>>>>", resdata);
          Object.keys(resdata).forEach(function(key) {
            
            if(key == 'subject'){
              setSubjectError(resdata[key]);
            }
            if(key == 'content'){
              setContentError(resdata[key]);
            }
            console.log('Key : ' + key + ', Value : ' + resdata[key])
          })
        } 
      }).catch(error => {
        console.log('error => ',error.response.data);
      })
  }


  return (
    <div className="wrapper">
        <div className="content-wrapper">
            <form  className="mx-5 col-md-5">
                <h2>Edit {contentData.key == "PrivacyPolicy" ? "Privacy Policy" : "Terms And Condition"}</h2>
                <div className="field form-group">               
                    <label>Language</label>
                    <select defaultValue={lang} className="form-control" name="lang" onChange={handleChange}>
                        <option value="en">English</option>
                        <option value="zh">Chinese</option>
                    </select>
                </div>
                
                <div className="ui form box-body">
                    <div className="field form-group">               
                        <label>Key</label>
                        <input type="text" name="key" autoComplete="nope" placeholder="Key" className="form-control" onChange={handleChange} value={contentData.key} readOnly />
                </div>

                <div className="field form-group">               
                        <label>Subject</label>
                        <input type="text" name="subject" autoComplete="nope" placeholder="Subject" className="form-control" onChange={handleChange} value={contentData.subject}/>
                        <div className="text-danger">
                            {subjectError ? subjectError : null}
                        </div>
                </div>

                <div className="field form-group">               
                        <label>Content</label>
                        {/* <textarea type="text" name="content" autoComplete="nope" placeholder="Content" rows="8" className="form-control" onChange={handleChange} value={contentData.content}></textarea> */}                        
                        <CKEditor editor={ClassicEditor} data={contentData.content} onChange={editorOnChnage}/>
                        <div className="text-danger">
                            {contentError ? contentError : null}
                        </div>
                 </div>
                <div className='btn-allign'>
                <button type="button" onClick={updateStaticContent} className="btn btn-danger submit-btn">Save</button>
                <Link to="/admin/static-content-list"><button className="btn btn-primary submit-btn">Back</button></Link>
                </div>
                </div>
            </form>
        </div>
    </div>
  )
}